
import { Button } from "@/components/ui/button";
import { Mail } from "lucide-react";
import ChatMessage from "./ChatMessage";
import { useEffect, useRef } from 'react';
import ScheduleButton from "./ScheduleButton";

interface ChatHistoryProps {
  messages: Array<{
    type: 'user' | 'ai';
    content: string;
    id: number;
  }>;
  isReadyToSchedule?: boolean;
  isAuthenticated: boolean;
  isLoading: boolean;
  parsedMeeting?: {
    attendeeName: string | null;
    dateTime: Date | null;
    duration?: number;
  } | null;
  onGoogleSignIn: () => void;
  onSchedule: () => void;
}

const ChatHistory = ({ 
  messages,
  isReadyToSchedule,
  isAuthenticated,
  isLoading,
  parsedMeeting,
  onGoogleSignIn,
  onSchedule,
}: ChatHistoryProps) => {
  const chatEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  return (
    <div className="flex justify-center p-4">
      <div className="w-full max-w-2xl space-y-4">
        {messages.map((message) => (
          <ChatMessage key={message.id} {...message} />
        ))}
        {isReadyToSchedule && parsedMeeting?.dateTime && parsedMeeting?.attendeeName && !isAuthenticated && (
          <div className="mt-4">
            <ScheduleButton
              isAuthenticated={isAuthenticated}
              isLoading={isLoading}
              isDisabled={false}
              onGoogleSignIn={onGoogleSignIn}
              onSchedule={onSchedule}
              meetingDetails={{
                attendeeName: parsedMeeting.attendeeName,
                dateTime: parsedMeeting.dateTime,
                duration: parsedMeeting.duration
              }}
            />
          </div>
        )}
        <div ref={chatEndRef} />
      </div>
    </div>
  );
};

export default ChatHistory;
